import { render } from "./PeaceRadioCourses.vue?vue&type=template&id=5d3946ae&scoped=true"
import script from "./PeaceRadioCourses.vue?vue&type=script&lang=js"
export * from "./PeaceRadioCourses.vue?vue&type=script&lang=js"

import "./PeaceRadioCourses.vue?vue&type=style&index=0&id=5d3946ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3946ae"]])

export default __exports__